import React, {useState, useEffect} from 'react';
import SecondaryTitle from "../../../../Components/SecondaryTitle";
import Text from "../../../../Components/Text";
import Spacer from "../../../../Components/Spacer";
import FormInput from "../../../../Components/Forms/FormInput";
import Button from "../../../../Components/Button";
import {JOURNEYS, prependJourneyToRouteName} from "../../../../constants";

const voucherParam = (new URLSearchParams(window.location.search)).get('voucher');

const VoucherDetails = (props) => {
    const {
        appliedVoucher      = null,
        setAppliedVoucher   = (value) => {},
        disabled            = false,
        journey             = JOURNEYS.AGENT,
    } = props;

    const [voucherCode, setVoucherCode] = useState(voucherParam || '');
    const [submitting, setSubmitting]   = useState(false);
    const [errors, setErrors]           = useState(null);

    useEffect(() => {
        if (!!voucherCode && voucherCode !== '') {
            setSubmitting(true);
        }
    }, []);

    useEffect(() => {
        if (submitting) {
            applyVoucherCode()
        }
    }, [submitting]);

    const applyVoucherCode = () => {
        setErrors(null);

        axios.patch(route(prependJourneyToRouteName(journey, 'session.stripe-voucher.update'), {session: window.session}).toString(), {voucher_code: voucherCode})
            .then((response) => {
                if (!!response && !!response.data && !!response.data.voucher) {
                    setAppliedVoucher(response.data.voucher);
                }
            })
            .catch((error) => {
                if (!!error && !!error.response && !!error.response.data) {
                    if (!!error.response.data.errors) {
                        setErrors(error.response.data.errors);
                    }

                    setSubmitting(false);
                } else {
                    console.log(error);
                }
            }).finally(() => {
                setSubmitting(false);
            });
    }

    const clearVoucherCode = () => {
        setVoucherCode('');
        setAppliedVoucher(null);
    }

    const shouldRenderDetails = () => {
        return !!appliedVoucher;
    }

    const renderVoucherInputControls = () => {
        return (
            <React.Fragment>
                <div style={{marginBottom: '21px', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start'}}>
                    <FormInput
                        name={'voucher_code'}
                        label={'Voucher code'}
                        value={voucherCode}
                        type={'text'}
                        onChange={(value) => setVoucherCode(value)}
                        disabled={submitting || disabled || shouldRenderDetails()}
                        error={errors}
                        style={{marginBottom: 0, marginRight: '10px'}}
                    />
                    <Button
                        label={submitting ? 'Redeeming...' : 'Redeem'}
                        disabled={submitting || disabled}
                        onClick={() => setSubmitting(true)}
                        style={{
                            marginTop: '12px',
                            marginLeft: '11px',
                            width: '25%',
                            minWidth: '100px',
                            background: 'transparent',
                            border: '1px solid #2d3047',
                            color: '#2d3047',
                            minHeight: 'auto',
                            padding: '10px',
                            boxShadow: 'none'
                        }}
                    />
                </div>
            </React.Fragment>
        );
    }

    const renderDetailRow = (title, value) => {
        return (
            <tr>
                <th>{title}</th>
                <td>{value}</td>
            </tr>
        )
    }

    const renderVoucherDetails = () => {
        return (
            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '21px'}}>
                <table className={'subscription-details'} style={{marginRight: '10px', marginBottom: 0}}>
                    <tbody>
                    {renderDetailRow('Code:', appliedVoucher.code)}
                    {renderDetailRow('Terms:', appliedVoucher.terms)}
                    </tbody>
                </table>
                <Button
                    label={'Clear'}
                    disabled={disabled}
                    onClick={() => clearVoucherCode()}
                    style={{
                        marginLeft: '11px',
                        width: '25%',
                        minWidth: '100px',
                        background: 'transparent',
                        border: '1px solid #2d3047',
                        color: '#2d3047',
                        minHeight: 'auto',
                        padding: '10px',
                        boxShadow: 'none'
                    }}
                />
            </div>
        );
    }

    return (
        <React.Fragment>
            <SecondaryTitle>Voucher code</SecondaryTitle>
            {!shouldRenderDetails() && (
                <Text>Have a voucher code? Enter the code below and click 'redeem'.</Text>
            )}
            {!shouldRenderDetails() ? renderVoucherInputControls() : renderVoucherDetails()}
            <Spacer />
        </React.Fragment>
    );
}

export default VoucherDetails;
